import Mutations from '../../odata/mutations';

export default { ...new Mutations('orgTaxRate'), ...new Mutations('orgTaxRates') };
